import { Theme } from 'app/lib/constants';
import { ThemeProvider } from 'app/components/core/ThemeProvider';
import { SqlCodeViewer } from 'app/components/core/CodeEditor';
import { Time, TimeFormat } from 'app/components/core/Time';
import { Duration } from 'app/components/core/Duration';

export const durationRenderer = (duration) => <Duration value={duration} />;

export const timeRenderer = (timeStamp) => (
    <Time value={timeStamp} format={TimeFormat.DATETIME_SHORT} />
);

export const sqlRenderer = (sql, breakWord) => (
    <ThemeProvider theme={Theme.LIGHT}>
        <SqlCodeViewer breakWord={breakWord} sql={sql ?? ''} allowCopyToClipboard fullHeight />
    </ThemeProvider>
);
